import { createTheme } from '@mui/material/styles';

export const getTheme = (mode) => createTheme({
  typography: {
    fontFamily: '"Heebo", sans-serif',
    h1: {
      fontFamily: '"Heebo", sans-serif',
    },
    h2: {
      fontFamily: '"Heebo", sans-serif',
    },
    h3: {
      fontFamily: '"Heebo", sans-serif',
    },
    h4: {
      fontFamily: '"Heebo", sans-serif',
    },
    h5: {
      fontFamily: '"Heebo", sans-serif',
    },
    h6: {
      fontFamily: '"Heebo", sans-serif',
    },
    subtitle1: {
      fontFamily: '"Heebo", sans-serif',
    },
    subtitle2: {
      fontFamily: '"Heebo", sans-serif',
    },
    body1: {
      fontFamily: '"Heebo", sans-serif',
    },
    body2: {
      fontFamily: '"Heebo", sans-serif',
    },
    button: {
      fontFamily: '"Heebo", sans-serif',
      textTransform: 'none',
    },
    caption: {
      fontFamily: '"Heebo", sans-serif',
    },
    overline: {
      fontFamily: '"Heebo", sans-serif',
    },
  },
  palette: {
    mode,
    primary: {
      main: mode === 'light' ? '#4F46E5' : '#92bbfe',
      button: mode === 'light' ? '#92bbfe' : '#92bbfe',
      light: mode === 'light' ? '#818CF8' : '#818CF8',
      dark: mode === 'light' ? '#3730A3' : '#4F46E5',
    },
    secondary: {
      main: mode === 'light' ? '#0EA5E9' : '#0EA5E9', // Mantener color sky blue para dark también
      light: mode === 'light' ? '#38BDF8' : '#38BDF8',
      dark: mode === 'light' ? '#0284C7' : '#0284C7',
    },
    error: {
      main: '#EF4444', // Red actualizado
      light: '#F87171',
      dark: '#DC2626',
    },
    success: {
      main: '#10B981', // Emerald actualizado
      light: '#34D399',
      dark: '#059669',
    },
    disabled: {
      main: '#94A3B8', // Slate 400 para light
      light: '#94A3B8',
      dark: '#64748B',
    },
    background: {
      default: mode === 'light' ? '#e3edfd' : '#1f2125', // Fondo más oscuro
      paper: mode === 'light' ? '#FFFFFF' : '#2b2f34', // Tarjetas más oscuras
      paper2: mode === 'light' ? '#FFFFFF' : '#363a40', // Tarjetas con tono más claro en modo oscuro
      medium: mode === 'light' ? '#F1F5F9' : '#252525', // Slate 100 para light
      enfasis: mode === 'light' ? '#6366f2' : '#6366f2',
      transparent: mode === 'light' ? 'rgba(255, 255, 255, 0.75)' : 'rgba(18, 18, 18, 0.75)',
    },
    text: {
      primary: mode === 'light' ? '#1E293B' : '#F8F9FA', // Texto más blanco en dark
      secondary: mode === 'light' ? '#475569' : '#A0AEC0', // Gris más claro
      disabled: mode === 'light' ? '#94A3B8' : '#64748B', // Slate 400 para light
    },
    status: {
      success: '#10B981', // Emerald
      warning: '#F59E0B', // Amber actualizado
      error: '#EF4444', // Red
      info: '#3B82F6', // Blue actualizado
    },
    shadow: {
      default: mode === 'light'
        ? '0px 8px 24px rgba(148, 163, 184, 0.2)' // Sombra más notable pero moderna
        : '0px 4px 20px rgba(0, 0, 0, 0.5)' // Sombra más intensa en dark
    }
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: mode === 'light' ? '#FFFFFF' : '#121212',
          borderBottom: `1px solid ${mode === 'light' ? 'rgba(148, 163, 184, 0.1)' : 'rgba(255, 255, 255, 0.06)'}`,
          boxShadow: mode === 'light' 
            ? '0px 2px 8px rgba(148, 163, 184, 0.16)'
            : '0px 2px 4px rgba(0,0,0,0.5)',
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
        },
        contained: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          borderRadius: 12,
          boxShadow: mode === 'light' 
            ? '0px 4px 16px rgba(148, 163, 184, 0.16)'
            : '0px 2px 8px rgba(0,0,0,0.5)',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          backgroundColor: mode === 'light' ? '#FFFFFF' : '#1E1E1E',
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          backgroundColor: mode === 'light' ? '#FFFFFF' : '#1E1E1E',
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          '&:hover': {
            backgroundColor: mode === 'light' ? '#F1F5F9' : '#252525',
          },
          '&.Mui-selected': {
            backgroundColor: mode === 'light' ? '#E0E7FF' : '#303030',
          },
        },
      },
    },
  },
});

// Export both themes
export const lightTheme = getTheme('light');
export const darkTheme = getTheme('dark');

// Export default theme (light)
export default lightTheme; 